export enum ZoomEmitValues {
  Increase = 'Increase',
  Decrease = 'Decrease',
  FitToWidth = 'FitToWidth',
  FitToHeight = 'FitToHeight'
}
